// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hYh1k","label":"styles_label__3jQLW"};